module.exports = __webpack_public_path__ + "media/images/event/event-template-ge-ab682a85f06c6761c6ca254742f8c1ae.png";